module.exports = __webpack_public_path__ + "static/media/blog28-2.859e853e.webp";